/* ============================= E X P O R T ============================= */

export default {
  name: 'ExclamTrian',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary',
        'red',
        'yellow-bold'
      ]
    }
  }
}
